import { render } from "./CreateTownView.vue?vue&type=template&id=0be2807d&scoped=true"
import script from "./CreateTownView.vue?vue&type=script&lang=js"
export * from "./CreateTownView.vue?vue&type=script&lang=js"

import "./CreateTownView.vue?vue&type=style&index=0&id=0be2807d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be2807d"]])

export default __exports__